var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-writer-drag-handle.ts
import "@adornis/ass/style.js";
import { logger } from "@adornis/base/logging.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { debounceTime, fromEvent, Subject, takeUntil } from "rxjs";
import { writerMarker } from "./x-plain-writer.js";
var _a;
var XWriterDragHandle = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this[_a] = true;
    this.dragging = false;
    this.dragStart = 0;
    this.preDragWidth = 0;
    this.hideTimer = new Subject();
  }
  static {
    _a = writerMarker;
  }
  styles() {
    return [
      {
        ":host": {
          position: "fixed",
          top: "-30px",
          left: "-30px",
          opacity: "0",
          transition: "opacity 0.3s linear"
        }
      }
    ];
  }
  connectedCallback() {
    super.connectedCallback();
    const handleMouseup = (event) => {
      this._handle.style.cursor = "-webkit-grab";
      document.removeEventListener("mousemove", handleMousemove, false);
      document.removeEventListener("mouseup", handleMouseup, false);
      this.dragging = false;
      event.preventDefault();
    };
    const handleMousemove = (event) => {
      const delta = event.clientX - this.dragStart;
      this.img.style.setProperty("width", `${Math.round(this.preDragWidth + delta)}px`);
      this.moveToImg();
      event.preventDefault();
    };
    fromEvent(this, "mousedown").pipe(takeUntil(this.disconnected)).subscribe((event) => {
      if (!this.img)
        return logger.warn("a-writer-drag-handle clicked without it having an image.");
      this.dragStart = event.clientX;
      this.preDragWidth = +this.img.style.getPropertyValue("width").slice(0, -2);
      this._handle.style.cursor = "-webkit-grabbing";
      document.addEventListener("mousemove", handleMousemove, false);
      document.addEventListener("mouseup", handleMouseup, false);
      this.dragging = true;
      event.preventDefault();
    });
    this.hideTimer.pipe(debounceTime(500), takeUntil(this.disconnected)).subscribe(() => this.hide());
  }
  render() {
    return html`
      <svg
        ${ref((handle) => this._handle = handle)}
        id="handle"
        style="cursor:-webkit-grab;width:28px;height:20px;"
        viewBox="0 0 26 12"
      >
        <path style="stroke:#000;fill:#FFF;" d="M1,6L6,1L8,3L7,4H19L18,3L20,1L25,6L20,11L18,9L19,8H7L8,9L6,11Z"></path>
      </svg>
    `;
  }
  moveToImg() {
    if (!this.img)
      return logger.warn("a-writer-drag-handle trying to move to img, but no img is set.");
    this.hideTimer.next();
    this.img.contentEditable = "false";
    const bounds = this.img.getBoundingClientRect();
    this.style.top = `${bounds.top + bounds.height / 2 - 10}px`;
    this.style.left = `${bounds.left + bounds.width - 14}px`;
    this.style.opacity = "1";
  }
  show(img) {
    if (this.dragging)
      return;
    this.img = img;
    this.moveToImg();
  }
  hide() {
    if (this.dragging)
      return;
    this.style.opacity = "0";
    setTimeout(() => {
      this.style.top = "-30px";
      this.style.left = "-30px";
    }, 300);
  }
};
XWriterDragHandle = __decorateClass([
  customElement("x-writer-drag-handle")
], XWriterDragHandle);
export {
  XWriterDragHandle
};
